import React, { useEffect, useRef, useState } from "react";
import { ControlLabel, FormGroup, HelpBlock } from "react-bootstrap";
import { CustomToolTip, TooltipReact } from "../../atoms/tooltip/index";

const renderToolTip = ({ toolTip, id = 1 }) => {
  return <TooltipReact align="top" toolTip={toolTip()} id={id} />;
};

const TextAreaInput = ({
  field: { name, value, onChange, disabled },
  form: { errors, touched },
  label = "",
  labelStyles = {},
  valueStyles = {},
  tooltipStyles = {},
  type = "text",
  min,
  placeholder = "",
  handleBlur,
  showError = true,
  className = "",
  maxLength = 100,
  enableTextAreaRef = true,
  /////////////////

  info,
  message,
  style,
  divStyle,
  tooltipWidth = "300px",
  alignLeft = false,
  shouldShowRemainingCharacters = true,
  ...props
}) => {
  const textAreaRef = useRef();

  const [firstRender, setFirstRender] = useState(true);

  const resizeTextArea = () => {
    const textRef = textAreaRef.current;
    if (textRef) {
      textRef.style.height = "auto"; // Temporarily set to auto to force a reflow
      textRef.style.height = `${textRef.scrollHeight}px`;
      textRef.style.overflow = "hidden";
      textRef.style.fontFamily = "Montserrat Regular";
    }
  };

  // TODO improve upon this solution, identify why first render causes scrollheight to be zero
  useEffect(() => {
    if (firstRender) {
      setTimeout(() => {
        resizeTextArea();
        setFirstRender(false);
      }, 0); // Delay to ensure DOM is fully updated, this correctly gets the scroll height correctly
    } else {
      resizeTextArea();
    }
  }, [value, textAreaRef]);

  const remainingCharators = () => {
    return textAreaRef.current
      ? textAreaRef.current.value.length + `/${maxLength}`
      : `0/${maxLength}`;
  };

  const handleKeyDown = (e) => {
    resizeTextArea();
  };

  return (
    <FormGroup
      controlId={name}
      validationState={touched[name] && errors[name] ? "error" : null}
      className={className}
    >
      {label && (
        <div className="text-area-tooltip">
          <ControlLabel style={labelStyles}>{label}</ControlLabel>
          {info && (
            <span
              style={{
                marginBottom: "5px",
                marginLeft: 10,
                ...tooltipStyles,
              }}
            >
              {renderToolTip({
                id: `tool-tip${name}`,
                toolTip: () => <CustomToolTip textOne={<div>{message}</div>} />,
              })}
            </span>
          )}
        </div>
      )}
      <textarea
        ref={enableTextAreaRef ? textAreaRef : null}
        name={name}
        disabled={disabled}
        value={value || ""}
        onChange={onChange}
        onBlur={() => {
          if (typeof handleBlur === "function") {
            handleBlur(value);
          }
        }}
        className="form-control custom-form-control"
        placeholder={placeholder}
        maxLength={maxLength || null}
        style={valueStyles}
        onKeyDown={(e) => handleKeyDown(e)}
        {...props}
      />

      {shouldShowRemainingCharacters && maxLength && !props.disabled && !errors[name] && (
        <div
          style={{ textAlign: "right", color: "var(--grey-20, #C9CBCF)", padding: "6px 2px" }}
        >
          {remainingCharators()}
        </div>
      )}
      {showError && <HelpBlock>{touched[name] && errors[name]}</HelpBlock>}
    </FormGroup>
  );
};

export { TextAreaInput };
